import { render, staticRenderFns } from "./DetailCategory.vue?vue&type=template&id=66f809e7&"
import script from "./DetailCategory.vue?vue&type=script&lang=js&"
export * from "./DetailCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports